import { getFloor } from "../../utils/helpers";

// Helper function to compare tips (handles both strings and objects)
const compareTips = (tip1, tip2) => {
  // Convert both tips to strings for comparison
  const str1 = typeof tip1 === 'object' 
    ? Object.values(tip1).find(v => typeof v === 'string' && v.includes('SYSTEM')) || 'SYSTEM'
    : String(tip1);
  
  const str2 = typeof tip2 === 'object' 
    ? Object.values(tip2).find(v => typeof v === 'string' && v.includes('SYSTEM')) || 'SYSTEM'
    : String(tip2);

  return str1 === str2;
};

// remove bets by one
export const getNewBets = (betsObject, eventId, betType, betResult) => {
  let betsObjectCopy = JSON.parse(JSON.stringify(betsObject)); // Deep clone
  if (betsObjectCopy[eventId]) {
    let returnedObj = { [eventId]: [] };

    betsObjectCopy[eventId].forEach(oneBet => {
      const betKey = Object.keys(oneBet)[0];
      const oneBetProps = oneBet[betKey];
      
      // Compare both tip and result
      const isSameTip = compareTips(oneBetProps.tip, betType);
      const isSameResult = String(betResult) === String(oneBetProps.result);
      
      // Skip if both match (this bet should be removed)
      if (isSameTip && isSameResult) return;
      
      // Otherwise keep the bet
      returnedObj[eventId].push(oneBet);
    });

    betsObjectCopy[eventId] = returnedObj[eventId];
    return betsObjectCopy;
  }
  return betsObjectCopy;
};

// remove all bets by one event
export const getNewBetsEventDelete = (eventsForBetting, eventId) => {
  const eventsForBettingCopy = { ...eventsForBetting };

  if (eventsForBettingCopy[eventId]) {
    delete eventsForBettingCopy[eventId];
  }

  return eventsForBettingCopy;
};

// get summary data from events object with bets
export const getSumDataFromBetsObject = betsObject => {
  let tempTotalStake = 0;
  let tempMaxWinning = 0;
  let betsCount = 0;
  let tempMaxWinningPerTicket = [];
  // set total stake for betslip
  Object.keys(betsObject).map((eventId, i) => {
    const eventObj = betsObject[eventId];
    let maxWinPerTicket = 0;
    eventObj.map(oneBet => {
      const oneBetProps = oneBet[Object.keys(oneBet)[0]];
      const stakeFormated = Number(
        String(oneBetProps.stake).replace(",", ".")
      );

      const odds = Number(String(oneBetProps.odds).replace(",", "."));

      tempTotalStake = stakeFormated + tempTotalStake;
      tempMaxWinning = tempMaxWinning + stakeFormated * odds;
      betsCount = betsCount + 1;
      maxWinPerTicket =
        maxWinPerTicket +
        Number(oneBetProps.stake) * Number(oneBetProps.odds);

      return oneBetProps;
    });

    tempMaxWinningPerTicket.push(maxWinPerTicket);

    return eventId;
  });

  return {
    tempTotalStake: getFloor(tempTotalStake, 10000),
    tempMaxWinning: tempMaxWinning,
    betsCount: betsCount,
    maxWinningPerTicket: tempMaxWinningPerTicket
  };
};

// get tip data from object with bets for betslip
export const getTipDataFromBetsObject = betsObject => {
  let betTipData = [];
  let stake = 0;
  let totalStake = 0;

  betsObject.map((oneBet, i) => {
    const oneBetProps = oneBet[Object.keys(oneBet)[0]];
    stake = oneBetProps.stake;
    const stakeFormatted = Number(
        String(oneBetProps.stake).replace(",", ".")
    );
    totalStake = stakeFormatted + totalStake;
    betTipData.push({
      betType: oneBetProps.betType,
      values: oneBetProps.resultForRequest,
      stake: stake
    })
    return oneBetProps;
  });

  return {
    tips: betTipData,
    totalStake: totalStake
  };
};

// check if total stake amount bigger than user's credits
export const checkIfCreditsValueIsLow = (
  totalStakeForLowCredits,
  walletAmount
) => {
  const isCreditsLow = totalStakeForLowCredits > walletAmount;
  return isCreditsLow;
};

export const checkIfEmptyBetsObject = betsObject => {
  let isEmptyBetsObject = true;
  for (const betsByEvent of Object.keys(betsObject)) {
    if (betsObject[betsByEvent].length > 0) {
      isEmptyBetsObject = false;
      return isEmptyBetsObject;
    }
  }
  return isEmptyBetsObject;
};